<template>
    <div style="overflow: auto !important;" class="am-landing">
		<am-toolbar
			class="am-landing__toolbar"
			:active.sync="menu"
			@brand="onBrandClick"
			@contact="onContactClick"
		/>

		<transition name="navigation">
			<div
				class="am-landing__navigation"
				v-if="menu"
			>
				<div class="am-landing__container">
					<am-list-external
						class="am-landing__menu"
						:items="navigation"
						@input="onMenuChange"
					/>
				</div>
			</div>
		</transition>

		<am-blog-inside
			v-if="blog.init"
			class="am-landing__view"
			:blog="blog"
			@gallery="onGalleryOpen"
			@submit="$store.commit('contact/submit', $event)"
			@click.native="menu = false; footer = false"
		/>
		<transition name="full-gallery">
			<am-full-gallery
				class="am-landing__full-gallery"
				v-if="gallery"
				:current="image"
				:images="images"
				@close="$store.commit('gallery/close')"
			/>
		</transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AMToolbar from '@/components/molecules/AMToolbarExternal'
import AMDown from '@/components/molecules/AMDown'
import AMListExternal from '@/components/molecules/AMListExternal'
import AMFullGallery from '@/components/organisms/AMFullGallery'
import AMFooter from '@/components/organisms/AMFooter'
import AMBlogInside from '@/components/templates/AMBlogInside'

import axios from 'axios';

export default {
    components: {
		'am-toolbar': AMToolbar,
		'am-down': AMDown,
		'am-list-external': AMListExternal,
		'am-full-gallery': AMFullGallery,
		'am-footer': AMFooter,
		'am-blog-inside': AMBlogInside
    },
    
    computed: {
		...mapGetters({
			viewport: 'viewport/getCurrent',
			navigation: 'navigation/getItems',
			section: 'navigation/getCurrent',
			anchors: 'navigation/getAnchors',
			gallery: 'gallery/getActive',
			image: 'gallery/getCurrent',
			images: 'gallery/getImages'
		}),

		menu: {
			get() { return this.$store.state.navigation.active },
			set(value) { this.$store.commit('navigation/setActive', value) }
		},
	},
	data: () => ({
		footer: false,

		// Acompanhe a obra
		blog: {
			titles: [
				'Desbrave.',
				'Ideias e',
				'Dicas.'
			],
			text: '',
			posts: [
				{
					id: 1, 
					title: "Entenda o que é a Arquitetura Moderna e quais são suas influências 1", 
					slug: "slug",
					category: "category",
					img: require('@/assets/images/hero/image.jpg'),
					text: "text",
					created_at: "created_at"
				},
				{
					id: 2, 
					title: "Entenda o que é a Arquitetura Moderna e quais são suas influências 1", 
					slug: "slug",
					category: "category",
					img: require('@/assets/images/hero/image.jpg'),
					text: "text",
					created_at: "created_at"
				},
				{
					id: 3, 
					title: "Entenda o que é a Arquitetura Moderna e quais são suas influências 1", 
					slug: "slug",
					category: "category",
					img: require('@/assets/images/hero/image.jpg'),
					text: "text",
					created_at: "created_at"
				}
			],
			background: require('@/assets/images/hero/background.jpg'),
			init: false
		},

	}) ,
	mounted () {
		axios
		.get(process.env.API + '/api/posts')
		.then(response => {
			// process.env.API + '/storage/posts/' + 
			this.blog.posts = response.data.data;
			this.blog.posts.forEach(e => {
				e.img = process.env.API + '/storage/posts/' + e.img;
			});
			console.log("resposta axios");
			this.blog.init = true;
			// console.log(this.timeline_inside2); 
		})
		/* console.log("fui chamado"); */
	},

	methods: {
		onBrandClick() {
			this.menu = false
			this.$store.commit('navigation/setCurrent', 'hero')
		},
		
		onMenuChange(value) {
			if (this.viewport == 'smartphone') {
				setTimeout(() => this.menu = false, 300)
				setTimeout(() => this.$store.commit('navigation/setCurrent', value), 500)
			} else {
				this.menu = false
				this.$store.commit('navigation/setCurrent', value)
			}
		},

		onDownClick() {
			if (this.section == 'contact')
				this.footer = !this.footer
			else
				this.$store.commit('navigation/next')
		},

		onGalleryOpen(payload) {
			this.$store.commit('gallery/open', payload)
		},

		onContactClick() {
			this.$store.commit('navigation/setCurrent', 'contact')
		}
	}
}
</script>

<style lang="scss">
body, html{
	height: 100%
}

.am-landing{
	display: flex;
	flex-flow: column;
	position: relative;

	&__toolbar{
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 40;
	}
	&__navigation{
		position: fixed;
		width: 100%;
		top: 60px;
		left: 0;
		bottom: 0;
		background: white;
		padding: 0 24px;
		box-sizing: border-box;
		z-index: 30;
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.04);
	}
	&__container,
	&__menu{
		height: 100%;
	}
	&__full-gallery{
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 100;
	}
	&__below{
		position: absolute;
		left: 0;
		width: 100%;
		bottom: 0;
		transform: translateY(100%);
		transition: .3s $easeInOutQuad;
		display: none;
		&.is-active{
			transform: translateY(0%);
		}
	}
	&__down{
		position: absolute;
		bottom: 100%;
		left: 50%;
		transform: translateX(-50%);
		z-index: 50;
	}
	&__footer{
		width: 100%;
	}

	@include grid-media($smartphone-grid) {
		.am-landing{
			//
		}
	}

	@include grid-media($desktop-grid) {
		&__navigation{
			height: auto;
			bottom: inherit;
			padding: 24px;
		}
		&__container{
			@include outer-container;
		}
		&__menu{
			@include grid-column(12);
		}
		&__below{
			display: flex;
		}
		.am-landing{
			//
		}
	}
}
</style>


